<template>
  <div id="documentLoan" class="sun">
    <div class="documentLoan">
      <DocumentLoanTitle></DocumentLoanTitle>
      <DocumentLimitTransactionDebtorInformation
        v-if="isAgreed==true||isAgreed==false"
        :isAgreed="isAgreed"
        :mode="'loan'"/>
      <DocumentLimitTransactionLoanInformation
        v-if="loan && loan.offer && (isAgreed==true||isAgreed==false)"
        :isAgreed="isAgreed"
        :mode="'loan'"
        :offer="loan.offer"/>
      <DocumentLoanInput :isAgreed="isAgreedInput"
                         :offer="loan.offer"
                         @agree="agreeInput"
                         @disagree="disagreeInput"
                         v-if="loan && loan.offer && (isAgreedInput==true||isAgreedInput==false)"></DocumentLoanInput>
      <DocumentLoanAgree :isAgreed="isAgreedAgree"
                         @agree="agreeAgree"
                         @disagree="disagreeAgree"
                         v-if="isAgreedAgree==true||isAgreedAgree==false"></DocumentLoanAgree>
    </div>
    <button class="confirm"
            :class="{'active': isAgreedAgree && isAgreedInput}"
            @click="agree">
      완료
    </button>
  </div>
</template>

<script>
import DocumentLoanTitle from './components/DocumentLoanTitle'
import DocumentLoanInput from './components/DocumentLoanInput'
import DocumentLoanAgree from './components/DocumentLoanAgree'
import DocumentLimitTransactionDebtorInformation from './components/DocumentLimitTransactionDebtorInformation'
import DocumentLimitTransactionLoanInformation from './components/DocumentLimitTransactionLoanInformation'
import LoanService from '@/service/loan/LoanService'
import contractsApi from '@/api/now/contractsApi'

let self

export default {
  name: 'loan',
  components: {
    DocumentLimitTransactionDebtorInformation,
    DocumentLimitTransactionLoanInformation,
    DocumentLoanTitle,
    DocumentLoanInput,
    DocumentLoanAgree,
  },
  props: {},
  data: function () {
    return {
      term: null,
      loan: null,
      offer: null,
      isAgreed: null,
      isAgreedInput: null,
      isAgreedAgree: null,
    }
  },
  computed: {},
  async created() {
    self = this
    self.$store.commit('ui/headerTitle', '펀다소셜대부 약정서')
    self.$store.commit('ui/headerTitle', '펀다나우서비스 신청서')
    await self.getTerm()
    await self.getAgreement()
    await self.getLoan()
    // self.isAgreed = await self.checkTermIsAgreed()
    self.isAgreed = true
    if (self.isAgreed) {
      self.isAgreedInput = true
      self.isAgreedAgree = true
    }
  },
  methods: {
    async getTerm() {
      let { data } = await contractsApi.getTerm('LOAN')
      this.term = data
      if (!this.term) {
        alert('펀다소셜대부 약정서가 존재하지 않습니다.')
        await this.$router.push({ name: 'documents' })
      }
      return this.term
    },
    async getLoan() {
      this.loan = await LoanService.getLoanOngoing()
      return this.loan
    },
    async getAgreement() {
      let { data } = await contractsApi.getAgreementByTerm(this.term.uuid)
      this.agreement = data
      return this.agreement
    },
    async checkTermIsAgreed() {
      this.agreement = await this.getAgreement()
      if (this.agreement) {
        return this.agreement.is_agreed === true
      } else {
        return false
      }
    },
    agreeInput() {
      this.isAgreedInput = true
    },
    disagreeInput() {
      this.isAgreedInput = false
    },
    agreeAgree() {
      this.isAgreedAgree = true
    },
    disagreeAgree() {
      this.isAgreedAgree = false
    },
    agree() {
      if (!this.isAgreedInput) {
        alert('윗 내용에 동의해주시고 및 이율과 비용을 똑같이 작성해주세요.')
        return
      }
      if (!this.isAgreedAgree) {
        alert('윗 약관 수령함 여부와 설명 들었음 여부에 동의해주세요.')
        return
      }
      try {
        contractsApi.agreeTerm(this.term.uuid)
        this.$router.push({ name: 'documents' })
      } catch (e) { console.error(e, 'getAgreement') }
    },
  },
}
</script>

<style lang="scss" scoped>
  #documentLoan {
    height: calc(100vh - 60px);
    .documentLoan {
      width: 100%;
      height: calc(100% - 68px);
      overflow: auto;
    }
    .confirm {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 100%;
      height: 68px;
      font-size: 22px;
      color: #727d8c;
      font-weight: bold;
      background-color: #e3ecf6;
      z-index: 1000;

      &.active {
        color: white;
        background-color: #1baaf1;
      }
    }
  }
</style>
